<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <div
    class="member-card"
    [ngClass]="{
      'corporate-member-card': isCorporate,
      'bg-primary text-white': !isCorporate,
      'kid-member': isJuniorBluebirds,
      'nav-side-menu-card': isNavSideMenu,
    }"
  >
    <div class="d-flex flex-column justify-content-between h-100">
      <div class="d-flex justify-content-between">
        <!--Name and ID-->
        <div class="card-id text-start">
          <h5 class="mb-1 font-size-14 card-name" *ngIf="memberDetails$ | async as memberDetails">
            {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
          </h5>
          <div class="d-flex font-size-14">
            <div *notInPopulation="[populations.JuniorBluebirds]">{{ 'member.card.product.code' | translate }}</div>
            <div *inPopulation="[populations.JuniorBluebirds]">{{ 'member.card.product.code.kid' | translate }}</div>
            <div class="vertical-line-div mx-2 bg-white"></div>
            <div>ID: {{ memberCard.MemberId }}</div>
          </div>
        </div>
        <ng-container *ngIf="!isNavSideMenu">
          <!--Logo-->
          <ng-container *ngIf="!isCorporate && !isJuniorBluebirds"
            ><img class="card-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false"
          /></ng-container>
          <ng-container *ngIf="isCorporate"
            ><img class="card-logo" [src]="'logos/corporate-logo.png' | contentAssetImage" draggable="false"
          /></ng-container>
          <ng-container *ngIf="isJuniorBluebirds"
            ><img class="kids-card-logo" [src]="'logos/kid-logo.png' | contentAssetImage" draggable="false"
          /></ng-container>
        </ng-container>
      </div>

      <ng-container *ngIf="!isNavSideMenu">
        <!--Balances-->
        <div class="d-flex justify-content-between align-items-center" [ngClass]="{ invisible: isJuniorBluebirds }">
          <div class="d-flex align-items-end mb-0 w-100 bg-glass">
            <div
              class="card-account-no text-start d-flex align-items-center justify-content-between w-100"
              *ngIf="pointsBalance$"
            >
              <label class="mb-0 font-weight-400">{{ 'member.card.points.balance' | translate }}</label>
              <div class="d-flex align-items-center">
                <span class="material-symbols-outlined me-2">loyalty</span>
                <h5 class="font-size-18 m-0">{{ pointsBalance$ | async | number: '1.0-0' }}</h5>
              </div>
            </div>
          </div>
          <div class="d-block d-lg-none">
            <div class="barcode d-lg-none d-block">
              <button
                type="button"
                class="btn btn-white wallet-button border-0 p-0 d-flex justify-content-center align-items-center"
                [ngClass]="isCorporate ? 'text-primary-corporate' : 'text-primary'"
                [routerLink]="['/rewards/wallet']"
              >
                <span class="icon icon-qr-code font-weight-bold"></span>
                <span class="ms-1 font-weight-bold font-size-14">{{ 'member.card.show' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
